export default __webpack_public_path__ + "static/Wald-Anfang_rez-4aeff2ec18ae1d78de46eed95eb2d5fe.jpg";